import { StreetAddress } from '@/property-tax-reporting-tab/styles';
import { usePropertyDetails } from '@/utils/hooks/data/usePropertyDetails';
import { BouncingBox } from '@/widgets/bouncing-box-loader/bouncing-box-loader';
import useRegion from '../utils/hooks/useRegion';
import AddNote from './components/add-note';
import OutreachLetters from './components/outreach-letters';
import { getSubheading } from './utils';
import ViolationsGridWithFilters from './violations-table/violations-grid-with-filters';

export function ViolationsTab() {
  const { region } = useRegion();

  const { currentProperty, loading } = usePropertyDetails();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <BouncingBox />
      </div>
    );
  }

  return (
    <div className="max-w-[1300px] mx-auto">
      <div className="flex flex-col gap-2">
        <StreetAddress data-testid="property-address">
          {currentProperty.address}
        </StreetAddress>
        <div>{getSubheading(currentProperty)}</div>
      </div>

      <div className="flex gap-6 mt-6">
        <div className="w-2/3">
          <ViolationsGridWithFilters regionId={region} />
        </div>
        <div className="w-1/3">
          <OutreachLetters />
          <AddNote />
        </div>
      </div>
    </div>
  );
}
